<template>
  <div ref="matrialityRoot" class="custom-container" :class="{ 'in-view': inView }">
    <div class="background-section top-part skinc-container">
      <MaterialityTop class="content-item" />
    </div>
    <div class="background-section middle-part skinc-container">
      <h2 class="section-title content-item">Process</h2>
      <div class="middle-section-content content-item">
        <Process1 :link="componentLinks.right1" />
        <Process2 :link="componentLinks.right2" />
      </div>
    </div>
    <div class="background-section bottom-part skinc-container">
      <h2 class="section-title content-item">Result</h2>
      <div class="bottom-section-content content-item">
        <Result1 :link="componentLinks.impact" />
        <Result2 :link="componentLinks.right3" />
      </div>
    </div>
  </div>
</template>

<script>
import MaterialityTop from './MaterialityTop.vue';
import Process1 from './Process1.vue';
import Process2 from './Process2.vue';
import Result2 from './Result2.vue';
import Result1 from './Result1.vue';

export default {
  components: {
    MaterialityTop,
    Process1,
    Process2,
    Result1,
    Result2
  },
  data() {
    return {
      inView: false,
      componentLinks: {
        right1:
          'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9D%B4%ED%95%B4%EA%B4%80%EA%B3%84%EC%9E%90+%EC%B0%B8%EC%97%AC',
        right2:
          'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9D%B4%EC%A4%91+%EC%A4%91%EC%9A%94%EC%84%B1+%ED%8F%89%EA%B0%80',
        impact:
          'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C',
        right3:
          'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C'
      }
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([entry], obs) => {
        if (entry.isIntersecting) {
          this.inView = true;
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(this.$refs.matrialityRoot);
  }
};
</script>

<style scoped>
.custom-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 300vh;
}

.background-section {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.background-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transform: scaleX(0);
  transition: transform 1.2s cubic-bezier(0.25, 1, 0.5, 1);
}

.top-part {
  background-color: white;
  min-height: 40vh;
  position: relative;
  top: 0px;
  z-index: 1;
}

@media (max-width: 992px) {
  .top-part {
    position: relative;
  }
}

@media (max-width: 992px) {
  .custom-container {
    min-height: auto;
  }
}

.middle-part {
  min-height: 100vh;
  position: sticky;
  top: 0vh;
  z-index: 2;
}

@media (max-width: 992px) {
  .middle-part {
    position: relative;
  }
}

.middle-part::before {
  background: linear-gradient(to right, #f6f2f2 100%);
  transform-origin: left;
}

.in-view .middle-part::before {
  transform: scaleX(1);
  transition-delay: 0.4s;
}

.bottom-part {
  min-height: 100vh;
  position: sticky;
  top: 0vh;
  z-index: 3;
  margin-top: 60vh;
}

@media (max-width: 992px) {
  .bottom-part {
    position: relative;
    margin-top: 0vh;
  }
}

.bottom-part::before {
  background: linear-gradient(to left, #ffe4e1 100%);
  transform-origin: right;
}

.in-view .bottom-part::before {
  transform: scaleX(1);
  transition-delay: 0.8s;
}

.middle-section-content,
.bottom-section-content {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.middle-section-content > *,
.bottom-section-content > * {
  flex: 1;
  border-radius: 16px;
  overflow: hidden;
}

.section-title {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: bold;
  margin-bottom: 20px;
  color: #121212;
  padding: 0 20px;
}

@media (max-width: 992px) {
  .middle-section-content,
  .bottom-section-content {
    flex-direction: column;
  }
}
</style>
